export type ProductCollection = 'trophies_medals' | 'galway_crystal';

export const COLLECTIONS = {
  TROPHIES_MEDALS: 'trophies_medals' as ProductCollection,
  GALWAY_CRYSTAL: 'galway_crystal' as ProductCollection,
};

export interface CollectionInfo {
  id: ProductCollection;
  name: string;
  icon: string;
  description: string;
}

export const COLLECTION_INFO: Record<ProductCollection, CollectionInfo> = {
  trophies_medals: {
    id: 'trophies_medals',
    name: 'Trophies & Medals',
    icon: '🏆',
    description: 'Awards, trophies, medals, plates, and ribbons',
  },
  galway_crystal: {
    id: 'galway_crystal',
    name: 'Galway Crystal',
    icon: '💎',
    description: 'Premium crystal glassware and gifts',
  },
};
